/*
 * @Description: 全局方法属性的首字母请保持大写，以作区分
 * @Author: sun fei
 * @Date: 2022-01-05 14:35:33
 */
export default {
	data() {
		return {
			//年级列表集合
			GradeList: [
				{ gradeNumber: "", gradeName: "全部" },
				{ gradeNumber: "1", gradeName: "一年级" },
				{ gradeNumber: "2", gradeName: "二年级" },
				{ gradeNumber: "3", gradeName: "三年级" },
				{ gradeNumber: "4", gradeName: "四年级" },
				{ gradeNumber: "5", gradeName: "五年级" },
				{ gradeNumber: "6", gradeName: "六年级" },
				// { gradeNumber: "7", gradeName: "七年级" },
				// { gradeNumber: "8", gradeName: "八年级" },
				// { gradeNumber: "9", gradeName: "九年级" },
			],
			// 学科列表集合
			SubjectList: [
				{ subjectId: "jcsub01", subjectName: "语文" },
				{ subjectId: "jcsub02", subjectName: "数学" },
				{ subjectId: "jcsub03", subjectName: "英语" },
				{ subjectId: "jcsub13", subjectName: "物理" },
				{ subjectId: "jcsub14", subjectName: "化学" },
				{ subjectId: "jcsub15", subjectName: "生物" },
				{ subjectId: "jcsub11", subjectName: "历史" },
				//  {subjectId: 'jcsub12', subjectName: '地理'},
				{ subjectId: "jcsub08", subjectName: "思想品德" },
			],
			// 文件上传图片集合
			ImgList: {
				"mp3,wma,wav,m4a": require("./img/file-audio.svg"),
				"png,jpg,jpeg,bmp,gif": require("./img/file-picture.svg"),
				"ppt,pptx": require("./img/file-ppt.svg"),
				"flv,avi,mp4,wmv,asf": require("./img/file-video.svg"),
				"doc,docx": require("./img/file-word.svg"),
				"zip,rar,7z": require("./img/file-zip.svg"),
				"xlsx,xls": require("./img/file-excl.svg"),
				html: require("./img/file-html.svg"),
				pdf: require("./img/file-pdf.svg"),
				swf: require("./img/file-swf.svg"),
				tir: require("./img/file-tir.svg"),
				txt: require("./img/file-txt.svg"),
				default: require("./img/file-default.svg"), //默认
				5: require("./img/file-link.svg"), //链接
				3: require("./img/file-folder.svg"), //文件夹
			},
			//文件类型
			suffixType: {
				xls: ["xls", "xlsx", "xlsm"],
				doc: ["doc", "docx"],
				ppt: ["ppt", "pptx"],
				pdf: ["pdf"],
				audio: ["mp3", "wma"],
				video: ["mp4", "MP4", "avi", "wmv", "flv", "asf"],
				zip: ["zip", "7z", "rar", "apz"],
				txt: ["txt"],
				image: ["jpg", "jpeg", "gif", "png"],
			},
			//文件大类
			uploadType: {
				image: ["image"],
				video: ["video"],
				audio: ["audio"],
				file: ["xls", "doc", "ppt", "pdf", "zip", "txt"],
			},
		};
	},
	methods: {
		// 显示附件图片
		ShowImg(ext) {
			//返回imgList键值组成的数组
			let imgKeys = Object.keys(this.ImgList);
			let src = this.ImgList.default;
			imgKeys.forEach((item) => {
				if (item.indexOf(ext) > -1) {
					src = this.ImgList[item];
				}
			});
			return src;
		},
		// 判断文件类型
		UseFileType(map, key, defaultKey) {
			key = key.toString().toLocaleLowerCase();
			return (
				Object.keys(map)[Object.values(map).findIndex((i) => i.includes(key))] || defaultKey || ""
			);
		},

		// 通过年级名称来转换学校等级
		ConvertSchoolLevel(gradeName) {
			if (gradeName.search(/(初|七年级|八年级|九年级|7年级|8年级|9年级)/) !== -1) {
				return "cz";
			}
			return "xx";
		},
	},
};
